import { NAVBAR_ID } from '../../Navbar/constants';

export const disableGlobalScrollbar = (scrollbarGutter = 'stable') => {
  document.body.style.overflow = 'hidden';
  document.querySelector<HTMLElement>(`#${NAVBAR_ID}`)?.style.setProperty('overflow-y', 'scroll');
  document.querySelector('html')?.style.setProperty('scrollbar-gutter', scrollbarGutter);
};
